<template>
  <div class="ConsignmentSummaryReportRcvTable">
    <Table width="200" border :columns="periodColumnsList" :data="periodData" v-if="periodDateStr">
    </Table>
    <TablePage 
      :pageObj="pageObj"
      @changePage="changePage"
      :tableWidth="windowWidth" 
      :columnsList="columnsList" 
      :resultList="showData" 
      v-if="isData">
    </TablePage>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "ConsignmentSummaryReportRcvTable",
  created() {
  },
  data() {
    return {
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      periodColumnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("PERIOD");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'period',
          width: 80,
          align: "center",
        },
      ],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("ITEM");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'receivingNo',
          width: 60,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("RECIVING_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'invoiceNo',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("RECIVING_DATE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'receivingDate',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          title: 'MVT',
          key: 'mvt',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("INVOICE_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'invoiceNo',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VN_CODE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vendorCode',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_NUMBER");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'poNo',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("LINE_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'lineNo',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_TYPE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'poType',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("DELTA_PN");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'partNo',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VN_PART");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vendorPn',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("RECEIVE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'receivedQty',
          width: 100,
          sortable: true,
          align: "center",
        }
      ],
    }
  },
  methods: {
    ...mapGetters(["getWindowsWidth"]),
    changePage(page) {
      this.pageObj.page = page - 1
    }
  },
  computed: {
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 70
    },
    periodData() {
      return [{
        period: this.periodDateStr
      }]
    },
    showData() {
      return this.dataList.slice(this.pageObj.page, this.pageObj.page + this.pageObj.pageSize)
    }
  },
  watch: {
    dataList: {
      handler: function(newValue, oldValue) {
        this.pageObj.totalCount = newValue.length
        this.pageObj.totalPage = newValue.length / this.pageObj.pageSize == 0 ? parseInt(newValue.length / this.pageObj.pageSize) : parseInt(newValue.length / this.pageObj.pageSize) + 1
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    title: String,
    content: String,
    periodDateStr: String,
    dataList: Array,
  },
}
</script>

<style scoped>

</style>